/* tslint:disable */
/* eslint-disable */
/**
 * Procon BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DailyDeviceCountInfoDto,
  JsonFeedbackDataDto,
  ManufacturingRequestDto,
} from '../models/index';
import {
    DailyDeviceCountInfoDtoFromJSON,
    DailyDeviceCountInfoDtoToJSON,
    JsonFeedbackDataDtoFromJSON,
    JsonFeedbackDataDtoToJSON,
    ManufacturingRequestDtoFromJSON,
    ManufacturingRequestDtoToJSON,
} from '../models/index';

export interface CreateManufacturingBatchRequest {
    manufacturingRequestDto: ManufacturingRequestDto;
}

export interface GetDailyDeviceCountInfoRequest {
    oemId?: number;
}

export interface GetManufacturingBatchRequest {
    manufacturingRequestId: string;
}

export interface PutFeedbackDataRequest {
    file: Blob;
}

export interface PutJsonFeedbackDataRequest {
    jsonFeedbackDataDto: JsonFeedbackDataDto;
}

/**
 * FactoryFloorControllerApi - interface
 * 
 * @export
 * @interface FactoryFloorControllerApiInterface
 */
export interface FactoryFloorControllerApiInterface {
    /**
     * 
     * @summary Create a manufacturing batch with given info. Due to technical restrictions on serial numbers generation, it is not allowed to create more than 65536 devices daily per Oem Id.
     * @param {ManufacturingRequestDto} manufacturingRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryFloorControllerApiInterface
     */
    createManufacturingBatchRaw(requestParameters: CreateManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Create a manufacturing batch with given info. Due to technical restrictions on serial numbers generation, it is not allowed to create more than 65536 devices daily per Oem Id.
     */
    createManufacturingBatch(requestParameters: CreateManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * 
     * @summary Get the daily remaining and current number of devices to be manufactured for the given Oem Id.
     * @param {number} [oemId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryFloorControllerApiInterface
     */
    getDailyDeviceCountInfoRaw(requestParameters: GetDailyDeviceCountInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyDeviceCountInfoDto>>;

    /**
     * Get the daily remaining and current number of devices to be manufactured for the given Oem Id.
     */
    getDailyDeviceCountInfo(requestParameters: GetDailyDeviceCountInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyDeviceCountInfoDto>;

    /**
     * 
     * @summary Get a manufacturing batch with given manufacturing id
     * @param {string} manufacturingRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryFloorControllerApiInterface
     */
    getManufacturingBatchRaw(requestParameters: GetManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Get a manufacturing batch with given manufacturing id
     */
    getManufacturingBatch(requestParameters: GetManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * 
     * @summary Imports the feedback data from given csv file. An import with 8000 entries takes approx. 12 minutes.
     * @param {Blob} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryFloorControllerApiInterface
     */
    putFeedbackDataRaw(requestParameters: PutFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>>;

    /**
     * Imports the feedback data from given csv file. An import with 8000 entries takes approx. 12 minutes.
     */
    putFeedbackData(requestParameters: PutFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>>;

    /**
     * 
     * @summary Imports the feedback data from given json file.
     * @param {JsonFeedbackDataDto} jsonFeedbackDataDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryFloorControllerApiInterface
     */
    putJsonFeedbackDataRaw(requestParameters: PutJsonFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Imports the feedback data from given json file.
     */
    putJsonFeedbackData(requestParameters: PutJsonFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

}

/**
 * 
 */
export class FactoryFloorControllerApi extends runtime.BaseAPI implements FactoryFloorControllerApiInterface {

    /**
     * Create a manufacturing batch with given info. Due to technical restrictions on serial numbers generation, it is not allowed to create more than 65536 devices daily per Oem Id.
     */
    async createManufacturingBatchRaw(requestParameters: CreateManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['manufacturingRequestDto'] == null) {
            throw new runtime.RequiredError(
                'manufacturingRequestDto',
                'Required parameter "manufacturingRequestDto" was null or undefined when calling createManufacturingBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/factoryfloor/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ManufacturingRequestDtoToJSON(requestParameters['manufacturingRequestDto']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a manufacturing batch with given info. Due to technical restrictions on serial numbers generation, it is not allowed to create more than 65536 devices daily per Oem Id.
     */
    async createManufacturingBatch(requestParameters: CreateManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.createManufacturingBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the daily remaining and current number of devices to be manufactured for the given Oem Id.
     */
    async getDailyDeviceCountInfoRaw(requestParameters: GetDailyDeviceCountInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyDeviceCountInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['oemId'] != null) {
            queryParameters['oemId'] = requestParameters['oemId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/factoryfloor/batch/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyDeviceCountInfoDtoFromJSON(jsonValue));
    }

    /**
     * Get the daily remaining and current number of devices to be manufactured for the given Oem Id.
     */
    async getDailyDeviceCountInfo(requestParameters: GetDailyDeviceCountInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyDeviceCountInfoDto> {
        const response = await this.getDailyDeviceCountInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a manufacturing batch with given manufacturing id
     */
    async getManufacturingBatchRaw(requestParameters: GetManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['manufacturingRequestId'] == null) {
            throw new runtime.RequiredError(
                'manufacturingRequestId',
                'Required parameter "manufacturingRequestId" was null or undefined when calling getManufacturingBatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['manufacturingRequestId'] != null) {
            queryParameters['manufacturingRequestId'] = requestParameters['manufacturingRequestId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/factoryfloor/batch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get a manufacturing batch with given manufacturing id
     */
    async getManufacturingBatch(requestParameters: GetManufacturingBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getManufacturingBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Imports the feedback data from given csv file. An import with 8000 entries takes approx. 12 minutes.
     */
    async putFeedbackDataRaw(requestParameters: PutFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling putFeedbackData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/v1/factoryfloor/feedback`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Imports the feedback data from given csv file. An import with 8000 entries takes approx. 12 minutes.
     */
    async putFeedbackData(requestParameters: PutFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.putFeedbackDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Imports the feedback data from given json file.
     */
    async putJsonFeedbackDataRaw(requestParameters: PutJsonFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['jsonFeedbackDataDto'] == null) {
            throw new runtime.RequiredError(
                'jsonFeedbackDataDto',
                'Required parameter "jsonFeedbackDataDto" was null or undefined when calling putJsonFeedbackData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/factoryfloor/feedback/json`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JsonFeedbackDataDtoToJSON(requestParameters['jsonFeedbackDataDto']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Imports the feedback data from given json file.
     */
    async putJsonFeedbackData(requestParameters: PutJsonFeedbackDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.putJsonFeedbackDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
